import { connect } from 'react-redux'
import log, { Sentry } from 'blazar-sentry'

import isBrowser from 'utils/isBrowser'
import { version } from 'package.json'

if (isBrowser()) {
  window.addEventListener('unhandledrejection', (event) => {
    if (event.promise) {
      event.promise.catch((error) => {
        log.error(error)
      })
    }
  })
}

const mapStateToProps = (state) => ({
  dsn: process.env.SENTRY_DSN,
  release: version,
  environment: state.config.sentry.environment,
  whitelistUrls: [/blocket\.se/, /blocket\.io/],
  ignoreUrls: [/\/assets\/scripts\//],
  allowUrls: [/blocket\.se/],
  captureUnhandledRejections: false,
})

export default connect(mapStateToProps)(Sentry)
